import { registerExtensionFunction, registerExtensionComponent} from "@solidstarters/solid-core-ui";
import bondHandler from "./admin/extensions/bond-handler";
import userIdFormLoadTransaction from "./admin/extensions/userIdFormLoadTransaction"
import bondTransactionHandler from "./admin/extensions/bond-transaction-handler";
import BondTransactionTypeHandler from "./admin/extensions/bond-transaction-type-handler";
import bondContainerHandler from "./admin/extensions/bond-container-handler";
import voyageMasterHandler from "./admin/extensions/voyage-master-handler";
import bondTransactionOnLoadHandler from "./admin/extensions/bon-transaction-onLoad-handler";
import HoldContainer from "./admin/extensions/bond-transaction-details/bond-transaction-details-custom";
import RequiredCheckboxWidget from "./admin/extensions/terms-condition-custom-component";
import GenerateReport from "./admin/extensions/reports/generate-reports";
import GenerateTemplateFormat from "./admin/extensions/templates/generate-template-format";
import LineLocationFieldHandler from "./admin/extensions/LineLocationFieldHandler";


registerExtensionFunction('bondHandler', bondHandler);
registerExtensionFunction('userIdFormLoadTransaction', userIdFormLoadTransaction);
registerExtensionFunction('bondTransactionHandler', bondTransactionHandler);
registerExtensionFunction('BondTransactionTypeHandler', BondTransactionTypeHandler);
registerExtensionFunction('bondContainerHandler', bondContainerHandler);
registerExtensionFunction('voyageMasterHandler', voyageMasterHandler);
registerExtensionFunction('bondTransactionOnLoadHandler', bondTransactionOnLoadHandler);
registerExtensionFunction('LineLocationFieldHandler', LineLocationFieldHandler);


registerExtensionComponent('HoldContainer', HoldContainer, []);
registerExtensionComponent('RequiredCheckboxWidget', RequiredCheckboxWidget);
registerExtensionComponent('GenerateReport', GenerateReport, []);
registerExtensionComponent('GenerateTemplateFormat', GenerateTemplateFormat, []);




